import React from 'react';
import { TrackingSteps } from '@facephi/sdk-web-react';
import { ExtendedSdkProvider } from '../../providers';
import { Layout } from './Layout';

export type IProps = {
  children: React.ReactNode;
  withTracking: boolean;
  steps: TrackingSteps[];
};

export const LayoutWidget = ({ children, withTracking, steps }: IProps) => {
  return (
    <Layout>
      <ExtendedSdkProvider disabled={withTracking ? false : true} steps={steps}>
        {children}
      </ExtendedSdkProvider>
    </Layout>
  );
};
